export class WaitingRoom {
  Id: number
  IntakeId: number
  VideoSessionId: string
  VideoTokenId: string
}